import Axios from "axios";
import React, { useState, useEffect } from "react";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { useTranslation } from 'react-i18next';

export const DropDownDepartments = ({value, idClient, allowEmpty = false, ...props}) => {

    const { t } = useTranslation();
    const [ data, setData ] = useState([]);
    const [ defaultValue, setDefaultValue ] = useState();

    async function getData() {

        const res = await Axios.get(`${process.env.REACT_APP_API_URL}/api/v1/Department/list/${idClient}`);

        let tempArray = res.data.responseObject.map(item => {

            item.label = item.name;
            item.value = item.idDepartment;
            return item;
        });

        // Agregar opción vacía al inicio si allowEmpty es true
        if (allowEmpty) {
            const emptyOption = {
                label: t('dropdowns.allClientOption'),
                value: null,
                idDepartment: null,
                name: t('dropdowns.allClientOption')
            };
            tempArray.unshift(emptyOption);
        }

        setData(tempArray);

        // Si hay un value específico, buscarlo; si no y allowEmpty es true, usar la opción vacía
        let selected;
        if (value !== undefined && value !== null) {
            selected = tempArray.find(obj => obj.idDepartment === value);
        } else if (allowEmpty) {
            selected = tempArray[0]; // La opción vacía "Todo el cliente"
        } else {
            selected = tempArray[0]; // Primera opción del array
        }

        setDefaultValue(selected);
    }


    useEffect(() => {
        getData();
    },[value, idClient]);

    return (
        <Dropdown 
            className={props.className}
            options={data} 
            name={props.name} 
            disabled={props.disabled}
            onChange={item => props.onChange(item)} 
            value={defaultValue} 
            placeholder={t('dropdowns.selectDepartment')} />
    )

}